import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e3bee3fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "card",
  style: {"padding":"25px","height":"100%"}
}
const _hoisted_2 = { style: {"height":"100%","display":"flex","flex-direction":"column","justify-content":"space-between"} }
const _hoisted_3 = { class: "title fs-1 fw-semibold" }
const _hoisted_4 = { class: "row row-cols-1 row-cols-xl-2" }
const _hoisted_5 = { class: "d-flex justify-content-around" }
const _hoisted_6 = { class: "subtitle" }
const _hoisted_7 = { class: "d-flex justify-content-around" }
const _hoisted_8 = { class: "subtitle" }

import { IMachine } from '@/modern/types/dashboard';
import MachineData from '../ui/MachineData.vue';


export default /*#__PURE__*/_defineComponent({
  props: {
    lastMachine: null,
    freeWeekMachine: null,
    currentLanguage: null
  },
  setup(__props: any) {

const props = __props as {
  lastMachine: IMachine;
  freeWeekMachine: IMachine;
  currentLanguage: string;
}



const hasMachineData = (machine: IMachine | null | undefined) => {
  if (!machine) {
    return false;
  }

  return Boolean(machine.id && machine.name && machine.os_name);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t(`${__props.currentLanguage}.common.new_contents`)), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", null, [
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t(`${__props.currentLanguage}.page_dashboard.free_week_machine`)), 1),
            _createVNode(MachineData, {
              machine: __props.freeWeekMachine,
              href: `/laboratory/competition-machines/${__props.freeWeekMachine?.id}`,
              "current-language": __props.currentLanguage,
              loading: !hasMachineData(props.freeWeekMachine)
            }, null, 8, ["machine", "href", "current-language", "loading"])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", null, [
            _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t(`${__props.currentLanguage}.page_dashboard.championship_machine`)), 1),
            _createVNode(MachineData, {
              machine: __props.lastMachine,
              href: `/laboratory/competition-machines/${__props.lastMachine?.id}`,
              "current-language": __props.currentLanguage,
              loading: !hasMachineData(props.lastMachine)
            }, null, 8, ["machine", "href", "current-language", "loading"])
          ])
        ])
      ])
    ])
  ]))
}
}

})